import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import NavCarousel from '@/components/NavCarousel';
import FeatureCard from './components/FeatureCard';
import ScenarioSection from './components/ScenarioSection';
import MentorCard from './components/MentorCard';
import { HERO, FEATURE, PERSONALIZED, SCENARIO, MENTOR } from './config';
import styles from './index.module.scss';

export default function Agents() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image}>
          <h1>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section title={FEATURE.title} subTitle={FEATURE.subTitle}>
          <div className={styles.featureList}>
            {FEATURE.cards.map((item) => (
              <FeatureCard key={item.title} {...item} />
            ))}
          </div>
        </Section>

        <Section title={PERSONALIZED.title} subTitle={PERSONALIZED.subTitle}>
          <NavCarousel items={PERSONALIZED.items} className={styles.personalizedCarousel} />
        </Section>

        <Section
          title={SCENARIO.title}
          subTitle={SCENARIO.subTitle}
          background={SCENARIO.background}
        >
          <ScenarioSection image={SCENARIO.image} video={SCENARIO.video} cards={SCENARIO.cards} />
        </Section>

        <Section title={MENTOR.title} subTitle={MENTOR.subTitle}>
          <div className={styles.mentorList}>
            {MENTOR.cards.map((item) => (
              <MentorCard key={item.name} {...item} />
            ))}
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
